import ForgotPasswordCompleteContainer from "./forgotPasswordCompleteContainer";
import {Button, Result} from "antd";
import {RoutingPaths} from "../../routing/routingContainer";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import AuthenticationLayout from "../authenticationLayout";

export default function ForgotPasswordCompletePage() {

    const [submitted, setSubmitted] = useState<boolean>(false);

    return <AuthenticationLayout
        title={submitted ? undefined : "Utwórz nowe hasło"}>
        {submitted
            ? <ForgotPasswordCompleteSuccessResult/>
            : <ForgotPasswordCompleteFormContainer onAfterSubmit={() => setSubmitted(true)}/>}
    </AuthenticationLayout>;
}

function ForgotPasswordCompleteFormContainer(props: { onAfterSubmit: () => void }) {
    return <>
        <ForgotPasswordCompleteContainer onAfterSubmit={props.onAfterSubmit}/>
    </>;
}

function ForgotPasswordCompleteSuccessResult() {
    const navigate = useNavigate();

    return <Result
        title="Pomyślnie ustawiono nowe hasło. Możesz teraz się zalogować"
        status="success"
        extra={
            <Button type="default" onClick={() => navigate(RoutingPaths.login.route, {replace: true})}>
                Zaloguj się
            </Button>
        }
    />;
}
